import Image from 'next/image';
import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';
import useGetChainInfo from '@/hooks/useGetChainInfo';

import { Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function HibachiTradingTriggerFullDetails({ trigger }: Props) {
  const { getChainIconUrl } = useGetChainInfo();
  const chainId = trigger.context?.chainId || trigger.context?.chain_id || 8453;
  const chainName = chainId === 8453 ? 'Base' : `Chain ${chainId}`;

  const chainIconUrl = useMemo(() => {
    return getChainIconUrl(chainId);
  }, [chainId, getChainIconUrl]);

  const chainDisplay = useMemo(() => {
    return (
      <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
        {chainIconUrl && <Image src={chainIconUrl} width={16} height={16} alt={chainName} />}
        <span>{chainName}</span>
      </div>
    );
  }, [chainIconUrl, chainName]);

  const executedWhenDisplay = useMemo(() => {
    return (
      <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
        <Text as="span" variant="body-sm" color="muted">
          User trades on
        </Text>
        <Badge size="sm">Hibachi</Badge>
        <Text as="span" variant="body-sm" color="muted">
          platform
        </Text>
      </div>
    );
  }, []);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Chain" value={chainDisplay} />
      <KeyValueRow label="Executed when" value={executedWhenDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
